<input #fileInput type="file" style="display: none" (change)="selectFile($event)" [accept]="accept" />
<input [formControl]="formControl" readonly type="text" />

<vdr-chip (click)="fileInput.click()" style="cursor: pointer">
  <span class="facet-name">上传</span>
  {{ '更新' }}
</vdr-chip>
